<template>
	<div class="wrap">
		<component :is="currentRole"/>
		<div class="skinPeeler" @click="currentBlon = true"></div>
		<div class="skinList" :class="currentBlon ? 'on':''">
			<div class="tablist">
				<div class="list" :class="currentRole == 'view1' ? 'on':''"  @click="skinClick('view1')">
					<img src="../../assets/images/img1.jpg">
				</div>
				<div class="list gray" :class="currentRole == 'view2' ? 'on':''"  >
					<img src="../../assets/images/img2.jpg">
				</div>
			</div>
			<div class="clone" @click="currentBlon = false">关闭</div>
		</div>
	</div>
</template>
<script>
export default {
  data(){
    return {
      currentRole: "view2",
			currentBlon: false
		};
	},
	created(){
    
    this.utils.checkUser();

    this.currentRole = this.utils.storageGet("home-skin") || "view1";
	},
	methods:{
		skinClick(name){
      this.currentRole = name;
      this.utils.storageSet("home-skin",name);
		}
	},
	mounted(){
		// var that = this;
		// that.height = window.innerHeight - (320*that.utils.per());
		// that.ctheight = window.innerHeight - (560*that.utils.per());
	},
	components: {
		view1: () => import('@/pages/zidian/view.vue'),
		view2: () => import('@/pages/zidian/viewlast.vue')
	},
}
</script>
<style scoped>
	.gray{
    -webkit-filter: grayscale(100%);
    -moz-filter: grayscale(100%);
    -ms-filter: grayscale(100%);
    -o-filter: grayscale(100%);
    filter: grayscale(100%);
    filter: gray;
    opacity:0.7;
  }
</style>